import { HttpStatusCode } from "axios";
import descriptionService from "../../apiServices/masters/descriptionService";
import { alertConstants } from "../../helper/sweet-alert";
import { IDescriptionData } from "../../models/master/descriptions";
import { setDescription, setDescriptions } from "../../store/slices/master/descriptionSlice";

export function getDescription(id: number) {
    return async function (dispatch: any, getState: any) {
        let response = await descriptionService.getDescription(id);
        if (response?.success === true) {
            dispatch(setDescription(response.data));
        } else {
            console.log("error");
        }
    };
}

export function getAllDescription(
    configUserRole?: number,
    pageBlockId?: number,
    noOfItems?: number
) {
    return async function (dispatch: any, getState: any) {
        let response = await descriptionService.getAllDescription(
            configUserRole,
            pageBlockId,
            noOfItems
        );
        if (response?.success === true) {
            dispatch(setDescriptions(response.data));
        } else {
            console.log("error");
        }
    };
}

export function createDescription(data: any, callback: Function) {
    return async function (dispatch: any, getState: any) {
        let response = await descriptionService.createDescription(data);
        const name = data.get("title")
        if (response?.success === true) {
            callback(alertConstants.success);
        } else {
            if (response.status === HttpStatusCode.Conflict) {
                callback(alertConstants.conflict, name);
            } else {
                callback(alertConstants.error);
            }
        }
    };
}

export function deleteDescription(id: number, callback: Function) {
    return async function (dispatch: any, getState: any) {
        let response = await descriptionService.deleteDescription(id);
        if (response === true) {
            callback(alertConstants.inactiveSuccess);
        } else {
            callback(alertConstants.inactiveFailure);
        }
    };
}

export function updateDescription(
    data: IDescriptionData,
    id: number,
    callback: Function
) {
    return async function (dispatch: any, getState: any) {
        let response = await descriptionService.updateDescription(data, id);
        if (response?.success === true) {
            callback(alertConstants.success);
        } else {
            if (response.status === HttpStatusCode.Conflict) {
                callback(alertConstants.conflict);
            } else {
                callback(alertConstants.error);
            }
        }
    };
}